import {TextToolTip} from "components";
import {DeleteActionBtn, EditActionBtn} from "components";
import {allStatusesList, Statuses} from "fragments";
import {Svg} from "assets";

export const userDetails = (item) => {
    return [
        {
            list: [
                {
                    title: "General Info",
                    list: [
                        {
                            title: "First Name",
                            desc: item?.firstName,
                        },

                        {
                            title: "Last Name",
                            desc: item?.lastName,
                        },
                    ],
                },

                {
                    list: [
                        {
                            title: "Access Level",
                            desc: AccessLevelTypes?.[item?.accessLevel],
                        },
                    ],
                },

                {
                    list: [
                        {
                            title: "DOB",
                            desc: item?.dob,
                            dateRow: true,
                        },

                        {
                            title: "Position",
                            desc: item?.position,
                        },
                    ],
                },

                {
                    list: [
                        {
                            title: "Phone Number",
                            desc: item?.phone,
                            phoneRow: true,
                        },
                    ],
                },

                {
                    list: [
                        {
                            title: "Email",
                            desc: item?.email,
                        },
                    ],
                },

                {
                    list: [
                        {
                            title: "SSN",
                            desc: item?.ssn,
                        },

                        {
                            title: "DI#",
                            desc: item?.dl,
                        },
                    ],
                },
            ],
        },
        {
            list: [
                {
                    title: "Address",
                    list: [
                        {
                            title: "Street",
                            desc: item?.address?.street,
                        },
                    ],
                },

                {
                    list: [
                        {
                            title: "Unit/Suit #",
                            desc: item?.address?.unitNumber,
                        },
                    ],
                },

                {
                    list: [
                        {
                            title: "City",
                            desc: item?.address?.city,
                        },
                    ],
                },

                {
                    list: [
                        {
                            title: "State",
                            desc: item?.address?.state,
                        },
                    ],
                },

                {
                    list: [
                        {
                            title: "Country",
                            desc: item?.address?.country,
                        },
                    ],
                },

                {
                    list: [
                        {
                            title: "Zip Code",
                            desc: item?.address?.zip,
                        },
                    ],
                },
            ],
        },
    ];
};

export const usersHead = () => {
    return [
        {title: "First Name", name: "firstName", searchKey: 'firstName', sortType: "firstName"},
        {title: "Last Name", name: "lastName", searchKey: 'lastName', sortType: "lastName"},
        {title: "Phone Number", name: "phone", searchKey: 'phone', custom: false},
        {title: "Email", name: "email", searchKey: 'email', sortType: "email"},
        {
            title: "Status",
            name: 'status',
            disabled: true,
            filterList: [{name: "All", id: "All"}, ...allStatusesList],
            width: 149
        },
        {title: "Action", name: 'active', disabled: true, custom: false, width: 60},
    ];
};

export const usersBody = ({handleDelete, handleEit}) => {
    return [
        {
            rowText: (item) => (
                <TextToolTip text={item?.firstName} content={item?.firstName}/>
            ),
        },

        {
            rowText: (item) => (
                <TextToolTip text={item?.lastName} content={item?.lastName}/>
            ),
        },

        {
            rowText: (item) => (
                <TextToolTip text={item?.phone} content={item?.phone} phoneRow/>
            ),
        },

        {
            rowText: (item) => (
                <TextToolTip text={item?.email} content={item?.email}/>
            ),
        },

        {
            rowText: (item) => <Statuses status={item?.status}/>,
        },

        {
            rowText: (item) => (
                <div className="flex-all-center" style={{gap: 8}}>
                    <EditActionBtn onClick={() => handleEit(item)}/>
                    {/*<DeleteActionBtn onClick={() => handleDelete(item)} />*/}
                </div>
            ),
            notClickable: true,
        },
    ];
};

export const emptyState = (addUser) => {
    return {
        emptyBtnText: 'Add Member',
        notTitleText: 'No users added yet',
        notDescText: 'Start by inviting users to your platform so they can log in and access the system.',
        EmptySvg: Svg.EmptyUser,
        clickToEmptyAddButton: () => addUser(),
    }
}

export const AccessLevelEnum = {
    MEMBER: 'MEMBER',
    ADMIN: 'ADMIN',
}

export const AccessLevelTypes = {
    MEMBER: 'Member',
    ADMIN: 'Admin',
}

export const AccessLevelList = [
    {
        id: AccessLevelEnum.MEMBER,
        name: AccessLevelTypes.MEMBER
    },

    {
        id: AccessLevelEnum.ADMIN,
        name: AccessLevelTypes.ADMIN
    },
]